import React from 'react';

interface PropTypes {
  label: string;
  checked: boolean;
  onChangeYes: () => void;
  onChangeNo: () => void;
}

export const InfoFoundRadio = (props: PropTypes) => {
  return (
    <>
      <div style={{ display: 'flex', marginBottom: 5 }}>
        <input type="radio" checked={props.checked} onChange={props.onChangeYes} />
        <label style={{ marginLeft: 5, marginRight: 44 }}>Yes</label>
        <input type="radio" checked={!props.checked} onChange={props.onChangeNo} />
        <label style={{ marginLeft: 5, marginRight: 20 }}>No</label>
        <span>{props.label}</span>
      </div>
    </>
  );
};
